var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "table rate-table" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("tbody", [
      _c("tr", [
        _c("td", [_vm._v(_vm._s(_vm.reservation.additional_info || "-"))]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [_c("th", [_vm._v("Additional Information")])]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }